export const RETENTION_PREFIX = 'announcement-impression:'

export class ImpressionRetention {
    constructor({ storage = window.localStorage, tabId } = {}) {
        this.storage = storage
        this.tabId = tabId
    }

    retain(exposure) {
        this.storage.setItem(this.keyFor(exposure.id), JSON.stringify(exposure))
    }

    discard(exposureId) {
        this.retainedKeys()
            .filter((key) => key.endsWith(`:${exposureId}`))
            .forEach((key) => this.storage.removeItem(key))
    }

    recoverFor(userId) {
        return this.retainedKeys()
            .map((key) => this.read(key))
            .filter((exposure) => exposure != null && exposure.userId === userId)
    }

    keyFor(exposureId) {
        return `${RETENTION_PREFIX}${this.tabId}:${exposureId}`
    }

    retainedKeys() {
        const keys = []
        for (let index = 0; index < this.storage.length; index += 1) {
            const key = this.storage.key(index)
            if (key?.startsWith(RETENTION_PREFIX)) {
                keys.push(key)
            }
        }

        return keys
    }

    read(key) {
        try {
            return JSON.parse(this.storage.getItem(key))
        }
        catch (error) {
            console.error('ImpressionRetention: could not read a retained exposure:', error)

            return null
        }
    }
}
